import { Injectable } from '@angular/core';
import { CookieService } from 'web-common/src/app/cookie.service';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserStatusesModel } from '../user-statuses.datamodel';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class AdminUsersService {

  constructor(
    private http : HttpClient,
    private cookieService: CookieService
  ) {}

  private setHeaders(): HttpHeaders {
    let cookieString = 'id=' + this.cookieService.get('id') + '; user_token=' + this.cookieService.get('user_token') + ';';
    let headers = new HttpHeaders();
    headers.append('cookiestring', cookieString);
    headers.append('Content-Type', 'application/json');
    headers.append('apiVersion', '1');
    headers.append('appid', environment.appId);

    return headers;
  }

  public exportInvited = (pageNumber: number = 0, length: number = 100, email: string):
    Observable<string> => {

    const requestBody = {
      'pageNumber': pageNumber,
      'pageRecords': length,
      'search': decodeURIComponent(email.trim()),
      'sortField': 'email',
      'sortType': 'ASC'
    };

    const requestOptions = {
      headers: this.setHeaders(),
      responseType: 'text' as const
    };

    return this.http.post(environment.rw3apiURL + 'user/exportInvites/',
      requestBody,
      requestOptions
    )
      .pipe(
        catchError(error => {
          return error;
        })
      ) as Observable<string>;
  }


  public exportUsers = (pageNumber: number = 0, email: string = '', length: number = 100, showDisabled: boolean = false,
                        lastActive: string = 'ALL', showDisabledAccounts: boolean = true, showEnabledAccounts: boolean = true,
                        onlyAdmins: boolean = false, selectedRoles: string[] = [], selectedArea: string[] = [],
                        selectedAdditional: string[] = [], sortField: string, sortType: string, byAdminEmail: boolean):
    Observable<string> => {

    const requestBody = {
      'pageNumber': pageNumber,
      'pageRecords': length,
      'search': decodeURIComponent(email.trim()),
      'lastActive': lastActive,
      'roles': selectedRoles,
      'areaOfFocus': selectedArea,
      'additionalProfileInformation': selectedAdditional,
      'showDisabledAccounts': showDisabledAccounts,
      'showEnabledAccounts': showEnabledAccounts,
      'onlyAdmins': onlyAdmins,
      'sortField': sortField,
      'sortType': sortType
    };

    const requestOptions = {
      headers: this.setHeaders(),
      responseType: 'text' as const
    };
    let url = environment.rw3apiURL + 'user/exportUsers/';
    if (byAdminEmail) {
      url = url + 'email/';
    }
    return this.http.post(url,
      requestBody,
      requestOptions
    )
      .pipe(
        catchError(error => {
          return error;
        })
      ) as Observable<string>;
  }

  public updateUserStatus = (ids: string[], action: string):
    Observable<UserStatusesModel> => {

    let endpoint = '';
    const requestBody = {ids: ids};

    switch (action) {
      case 'ENABLE':
        endpoint = 'admin/actions/enable';
        break;
      case 'DISABLE':
        endpoint = 'admin/actions/disable';
        break;
      case 'REVOKE_ADMIN':
        endpoint = 'admin/actions/deny';
        break;
      case 'MAKE_ADMIN':
        endpoint = 'admin/actions/grant';
        break;
    }

    return this.http.patch<UserStatusesModel>(environment.rw3apiURL + endpoint, requestBody, {headers: this.setHeaders()})
      .map((response) => {
        return response;
      }, error => {
        return error;
      });
  }

}
